export default "__VITE_ASSET__BnxcmvDr__"